import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button } from '@sololearnorg/sol';
import { Container, i18n } from '../../../../symphony';

import { Reply } from '../Reply/Reply';
import { SlDiscussContext } from '../../global-constants';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { SlDataService } from '../../services/sl-data.service';
import { useComponentWillMount } from '../../../../shared/public/SlUtils/useComponentWillMount';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

import s from './Replies.scss';

interface IRepliesProps {
	currentPageNumber: number;
	sortType: number;
}

export function Replies({ currentPageNumber, sortType }: IRepliesProps) {
	useStyles(s);
	const { id: questionId } = useParams();
	const { actions$ } = Container.take(SlDiscussContext, SlActions);

	const answerClickHandler = () => {
		actions$.next({
			type: ActionType.OnAnswerButtonClick,
			requestType: RequestType.Parallel,
		});
	};

	useComponentWillMount(() => {
		actions$.next({
			type: ActionType.OnDiscussRepliesMount,
			requestType: RequestType.Parallel,
			data: {
				questionId,
				currentPageNumber,
				sortType,
			},
		});
	});

	useEffect(() => () => {
		actions$.next({
			type: ActionType.OnDiscussRepliesUnMount,
			requestType: RequestType.Parallel,
		});
	}, []);

	const { replies$: replies } = useContainerData(
		SlDiscussContext,
		SlDataService,
		['replies$'],
	);

	return (
		<div className="discuss-replies">
			{replies?.length ? (
				<>
					{replies.map((reply) => (
						<Reply replyData={reply} key={reply.id} />
					))}
					<Button
						size="s"
						onClick={answerClickHandler}
						className="discuss-replies__answer-button"
					>
						{i18n.t('web-discuss.answer-button')}
					</Button>
				</>
			) : null}
		</div>
	);
}
